export class SlateRestrictionsError extends Error {
    constructor(restrictions, updates, details) {
        super(`The update violates the slate restrictions`);
        this.name = 'SlateRestrictionsError';
        this.updates = updates;
        this.restrictions = restrictions;
        this.details = details;
    }
}
const areChildrenMoved = (children, newChildren) => {
    let cIdx = 0;
    let nIdx = 0;
    while (cIdx < children.length && nIdx < newChildren.length) {
        if (children[cIdx] === newChildren[nIdx]) {
            cIdx += 1;
            nIdx += 1;
        }
        else {
            cIdx += 1;
        }
    }
    return nIdx !== newChildren.length;
};
export const validateRawSlateUpdates = (slate, updates) => {
    const { lockedRootBlock = false, nonEditableBlocks = [], lockedChildrenBlocks = [], nonRemovableBlocks = [], } = slate.restrictions || {};
    const { rootBlock, updatedBlocks = [], removedBlocks = [] } = updates;
    const blocksByIds = slate.blocks.reduce((preValue, block) => (Object.assign(Object.assign({}, preValue), { [block.id]: block })), {});
    const violatesRootBlockRestriction = lockedRootBlock && rootBlock;
    const violatesEditBlockRestriction = nonEditableBlocks.find(id => updatedBlocks.find(updatedBlock => updatedBlock.id === id && (updatedBlock.props || updatedBlock.output)));
    const violatesLockedChildrenRestrictions = lockedChildrenBlocks.find(id => updatedBlocks.find(updatedBlock => updatedBlock.id === id &&
        updatedBlock.children &&
        areChildrenMoved(blocksByIds[id].children, updatedBlock.children)));
    const violatesRemoveBlockRestriction = nonRemovableBlocks.find(id => removedBlocks.find(removedBlock => removedBlock === id));
    if (violatesRootBlockRestriction ||
        violatesEditBlockRestriction ||
        violatesLockedChildrenRestrictions ||
        violatesRemoveBlockRestriction) {
        throw new SlateRestrictionsError(slate.restrictions, updates, {
            violatesRootBlockRestriction,
            violatesEditBlockRestriction,
            violatesLockedChildrenRestrictions,
            violatesRemoveBlockRestriction,
        });
    }
};
//# sourceMappingURL=validation.utils.js.map